<template>
  <div v-if="store.data.hasBlocks" class="tvprogram tvprogram-list" :class="store.isLoading ? 'is-loading' : ''">
    <ul>
      <li v-for="(block) in store.data.blocks" :title="block.title">
        <tv-program-block :block="block"></tv-program-block>
      </li>
    </ul>
  </div>
  <div v-else class="tvprogram tvprogram-list" :class="store.isLoading ? 'd-none' : ''">
    <p>{{statusText}}</p>
  </div>
</template>

<script>

import {store} from "./TvProgramStore";
import TvProgramBlock from "./TvProgramBlock.vue";

export default {
  name: 'TvProgramList',
  data: () => {
    return {
      store
    }
  },
  components: {
    TvProgramBlock
  },
  computed: {
    statusText(){
      if(this.store.emptyResult && this.store.filteredByUser()){
        return `Zu ihrer gewählten Suche wurde nichts gefunden.`;
      }
      return `Das TV Programm für heute kommt in Kürze. Schauen sie später noch mal vorbei.`;
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss">
</style>